import { Injectable, inject } from '@angular/core';
import { TwcRefreshLayerPluginService } from '../../../../twc.refresh-layer-plugin.service';
import { IFR_FLIGHT_RULES_PRODUCT_DATA } from './flight-rules-ifr.twc-product-data';

@Injectable({
  providedIn: 'root'
})
export class FlightRulesIfrPluginService {
  private readonly _twcPluginService = inject(TwcRefreshLayerPluginService);
  plugin$ = this._twcPluginService.create(IFR_FLIGHT_RULES_PRODUCT_DATA, {
    twcLayerTypes: ['web-tile']
  });
}
